var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 35,
    viewBox: "0 0 50 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01236 1.11698C2.09304 1.34103 22.6064 18.3433 23.4901 18.9186C24.6453 19.6707 25.0997 19.7316 26.0628 19.2637C26.5511 19.0262 29.4605 16.7104 33.9095 13.0176C37.7983 9.78984 42.5915 5.81191 44.5611 4.17785C46.8962 2.24031 48.0821 1.16904 47.9702 1.09822C47.7169 0.938507 1.95469 0.956989 2.01236 1.11698ZM0 17.9159C0 26.2188 0.0384945 33.0121 0.0855115 33.0121C0.132529 33.0121 2.32187 31.2243 4.95057 29.0392C7.57926 26.8541 11.6597 23.4734 14.018 21.5264C16.3764 19.5794 18.3101 17.9479 18.3149 17.9006C18.3199 17.8535 17.6379 17.2504 16.7996 16.5603C15.9612 15.8704 11.8962 12.4964 7.76605 9.06268C3.63594 5.62892 0.199006 2.81961 0.128409 2.81961C0.0526988 2.81961 0 9.0133 0 17.9159ZM48.2244 4.18081C47.4432 4.84194 43.4321 8.18301 39.3111 11.6053C35.1901 15.0275 31.8216 17.8634 31.8257 17.907C31.8298 17.9507 32.5737 18.5895 33.4787 19.3267C34.3837 20.0639 38.4233 23.4117 42.4555 26.7663C46.4878 30.121 49.8348 32.8668 49.8935 32.8683C49.9521 32.8697 50 26.1412 50 17.9159C50 6.04104 49.9635 2.96253 49.8224 2.96959C49.7249 2.97452 49.0057 3.51954 48.2244 4.18081ZM19.5101 20.0027C19.1859 20.2905 15.0504 23.7321 10.3202 27.6508C5.58991 31.5695 1.71634 34.8232 1.71207 34.8815C1.70795 34.9398 12.2195 34.9873 25.071 34.9873C37.9226 34.9873 48.4344 34.9398 48.4307 34.8815C48.4249 34.7911 30.5862 19.9036 30.0652 19.5544C29.9362 19.4681 29.5977 19.6577 28.9663 20.1701C28.4645 20.5774 27.5885 21.1338 27.0195 21.4063C26.0497 21.8709 25.9162 21.898 24.8852 21.8388C23.6091 21.7654 22.6254 21.3201 21.1754 20.1596C20.7 19.779 20.2635 19.4703 20.2053 19.4736C20.147 19.4768 19.8342 19.7148 19.5101 20.0027Z",
    fill: "url(#paint0_radial_833_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_833_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7419 34.9873) rotate(-66.8802) scale(36.9691 46.8797)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564246,
    stopColor: "#96C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8ECF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f4e91cb0ef08b00788debeaa9622ce5c.svg";
export { ForwardRef as ReactComponent };